/**
 * Compare object with id to a value
 * @param Obj1
 * @param value
 */
export function compareIdToValue(Obj1: any, value: any): boolean {
  // eslint-disable-next-line
  return Obj1.id == value;
}
